import type { JSX } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useQuery } from "urql";
import Loader from "../../shared/components/Loader";
import t from "../../shared/translations";
import ShowError from "../components/ShowError";
import LockedModal, { useLockedModal } from "../LockedModal";
import WithTasksSidebar from "../tasksSidebar";
import { query } from "./query";
import TaskChoiceDescription from "./TaskChoiceDescription";

function PathInPath(): JSX.Element {
    const location = useLocation();
    // Extract id from pathname: /task-choice/123/... -> 123
    const id = location.pathname.split("/")[2];
    const { openLockedModal, ...lockedProps } = useLockedModal();
    const [result] = useQuery({
        query,
        variables: { id },
    });

    let main = <div />;
    if (result.fetching) {
        main = <Loader />;
    } else if (result.error) {
        main = <ShowError />;
    } else if (!result.data.taskChoice) {
        main = <Navigate to="/landing" replace={true} />;
    } else {
        const taskChoice = result.data.taskChoice;
        main = <TaskChoiceDescription taskChoice={taskChoice} />;
    }

    return (
        <>
            <WithTasksSidebar
                openLockedModal={openLockedModal}
                activeItem={result.data?.taskChoice?.learningPathItem?.id}
                mainLabel={t("player.task-choice.tab-task-choice")}
                big={true}
            >
                {main}
            </WithTasksSidebar>
            <LockedModal {...lockedProps} />
        </>
    );
}

export default PathInPath;
